define('modules/editor/models/property_group_factory',['require','exports','module','base/class','underscore','./property_groups/size','./property_groups/geometry','./property_groups/idclass','./property_groups/section_geometry','./property_groups/text_content','./property_groups/border','./property_groups/background','./property_groups/html_content','./property_groups/custom_amp_script','./property_groups/form_label','./property_groups/form_submit_format','./property_groups/form_input_format','./property_groups/form_radio_format','./property_groups/form_content','./property_groups/form_geometry','./property_groups/action','./property_groups/label','./property_groups/button_style','./property_groups/button_geometry','./property_groups/form_conversion','./property_groups/form_integration_correodirect','./property_groups/video_content','./property_groups/image_content','./property_groups/page_defaults','./property_groups/page_popup','./property_groups/page_confirmation','./property_groups/page_notification','./property_groups/page_privacy','./property_groups/page_conversion','./property_groups/page_jquery_selector','./property_groups/page_gtm','./property_groups/social_facebook','./property_groups/social_twitter','./property_groups/social_google'],function(require, exports, module) {
  "use strict";

  var Class = require('base/class'),
      _ = require('underscore'),
      groups = [
        require('./property_groups/size'),
        require('./property_groups/geometry'),
        require('./property_groups/idclass'),
        require('./property_groups/section_geometry'),
        require('./property_groups/text_content'),
        require('./property_groups/border'),
        require('./property_groups/background'),
        require('./property_groups/html_content'),

        //form stuff
        require('./property_groups/custom_amp_script'),
        require('./property_groups/form_label'),
        require('./property_groups/form_submit_format'),
        require('./property_groups/form_input_format'),
        require('./property_groups/form_radio_format'),
        require('./property_groups/form_content'),
        require('./property_groups/form_geometry'),
        require('./property_groups/action'),
        require('./property_groups/label'),
        require('./property_groups/button_style'),
        require('./property_groups/button_geometry'),
        require('./property_groups/form_conversion'),
        require('./property_groups/form_integration_correodirect'),

        //video
        require('./property_groups/video_content'),

        //image
        require('./property_groups/image_content'),

        //page defaults
        require('./property_groups/page_defaults'),
        require('./property_groups/page_popup'),
        require('./property_groups/page_confirmation'),
        require('./property_groups/page_notification'),
        require('./property_groups/page_privacy'),
        require('./property_groups/page_conversion'),
        require('./property_groups/page_jquery_selector'),
        require('./property_groups/page_gtm'),

        //social
        require('./property_groups/social_facebook'),
        require('./property_groups/social_twitter'),
        require('./property_groups/social_google')
      ];

  var Serialization = {
    fromJSON: function(json) {
      return module.exports.create(json.name, _.omit(json, 'name'));
    }
  };

  var groupConstructors = _.foldl(groups, function(acc, Constructor) {
    acc[Constructor.prototype.name] = Constructor;
    return acc;
  }, {});

  module.exports = Class.extend(
  {
    constructor: function(options) {
      return module.exports.create(options.name, _.omit(options, 'name'));
    }
  },
  {
    create: function(groupName, options, parentModel) {
      _.extend(options, {parentModel: parentModel});
      var newPropertyGroup = new groupConstructors[groupName](options);
      //NOTE: not needed, see baseproperty constructor
      //newPropertyGroup.parent = parentModel;
      return newPropertyGroup;
    },
    fromJSON: Serialization.fromJSON
  });
});

